// utils/appletRouting.js
// Single source of truth for applet-type routing, shared by Sidebar, the
// dashboard shortcut grid, and the /applet/[id] fallback page.

// Applet type enum mapping (matching backend C# AppletTypes — 0-based)
export const AppletTypes = {
    System: 0,
    MultiItemList: 1,
    MultiVersionItemList: 2,
    OpenSinglePDF: 3,
    WebLinksList: 4,
    OpenSingleWebLink: 5,
    Directory: 6,
    SimplePhoneBook: 7,
    Training: 8,
    GeoDirectory: 9,
    Checklist: 10,
    Forms: 11,
    Group: 12,
}

export const APPLET_TYPE_LABELS = {
    0: 'System',
    1: 'PDF/Weblink List',
    2: 'Multi-Version PDF List',
    3: 'Single PDF',
    4: 'Weblinks List',
    5: 'Single Weblink',
    6: 'Directory',
    7: 'Phonebook',
    8: 'Training',
    9: 'Geo Directory',
    10: 'Checklist',
    11: 'Forms',
    12: 'Group',
    'MultiItemList': 'PDF/Weblink List',
    'MultiVersionItemList': 'Multi-Version PDF List',
    'OpenSinglePDF': 'Single PDF',
    'WebLinksList': 'Weblinks List',
    'OpenSingleWebLink': 'Single Weblink',
    'Directory': 'Directory',
    'SimplePhoneBook': 'Phonebook',
    'Training': 'Training',
    'GeoDirectory': 'Geo Directory',
    'Checklist': 'Checklist',
    'Forms': 'Forms',
    'Group': 'Group',
}

// C# enum MEMBER names by ordinal — what legacy Razor printed for a bare
// `@applet.AppletType` (e.g. "MultiItemList"), as distinct from the prettified
// APPLET_TYPE_LABELS above.
export const APPLET_TYPE_NAMES = Object.fromEntries(
    Object.entries(AppletTypes).map(([name, n]) => [n, name]))

/** Enum member name for an applet type that arrives as an ordinal or a name. */
export const appletTypeName = (raw) => {
    if (raw === null || raw === undefined || raw === '') return ''
    if (typeof raw === 'number' || /^\d+$/.test(String(raw).trim())) {
        return APPLET_TYPE_NAMES[Number(raw)] ?? String(raw)
    }
    return String(raw)
}

// Map each applet type to its portal route.
// Add new entries here as pages are converted.
export const getAppletHref = (applet) => {
    switch (applet.appletType) {
        case AppletTypes.SimplePhoneBook:
            return `/phonebook?id=${applet.id}`
        case AppletTypes.WebLinksList:
            return `/weblist?id=${applet.id}`
        case AppletTypes.MultiItemList:
            return `/pdflist?id=${applet.id}`
        case AppletTypes.MultiVersionItemList:
            return `/pdfmulti?id=${applet.id}`
        case AppletTypes.OpenSinglePDF:
            return `/pdfsingle?id=${applet.id}`
        case AppletTypes.OpenSingleWebLink:
            return `/websingle?id=${applet.id}`
        case AppletTypes.Directory:
            return `/directory?id=${applet.id}`
        case AppletTypes.GeoDirectory:
            return `/geodirectory?id=${applet.id}`
        default:
            return `/applet/${applet.id}`
    }
}
